import { Tie } from '../_shared/models/tie.model';
import { TieDetailsService } from '../ties/tie-details/tie-details.service';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { Capacitor } from '@capacitor/core';
import { ModalController, Platform, SegmentCustomEvent, SegmentValue } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { BoardHelpService, TieScore } from '../match-tracker/tracker-board/board-help.service';
import { TrackerBoardComponent } from '../match-tracker/tracker-board/tracker-board.component';
import { TrackerBarComponent } from '../scoreboard/tracker-bar/tracker-bar.component';
import { LoaderService } from '../_core/services/loader.service';
import { MatchService } from '../_core/services/match.service';
import { ToastService } from '../_core/services/toast.service';
import { StopwatchComponent } from '../_shared/components/stopwatch/stopwatch.component';
import { MatchUpStatusEnum } from '../_shared/models/csTypes/enums/matchup_status';
import { WinReasonEnum } from '../_shared/models/csTypes/enums/win_reason';
import { InterruptionReason } from '../_shared/models/enums/interruption-reason';
import { Match } from '../_shared/models/match.model';
import { Set } from '../_shared/models/set.model';
import { MatchTrackerService } from '../match-tracker/match-tracker.service';
import { ThemeService } from '../_core/services/theme.service';

import { ScreenOrientation } from '@capacitor/screen-orientation';
import { RefresherCustomEvent } from '@ionic/angular';
import { StartMatchService } from '../match-tracker/start-match/start-match.service';
import { ScoreFormat, SetType } from '../_shared/models/score-format.model';
import { ClockName } from '../_shared/models/enums/clock-name.enum';
import { Clock } from '../_shared/models/clock.model';
import { OfficialViewService } from '../official-view/official-view.service';
import { InfringementListComponent } from '../official-view/infringement-list/infringement-list.component';
import { Socket } from 'ngx-socket-io';
import { Point } from '../_shared/models/point.model';
import { ScoreService } from '../match-tracker/tracker-board/services/score.service';
import { ScoreSummaryComponent } from './score-summary/score-summary.component';
import { IonModal } from '@ionic/angular/common';
import { ClocksComponent } from '../clocks/clocks.component';
import { ClocksService } from '../clocks/clocks.service';
import { IntSelectServerComponent } from './int-select-server/int-select-server.component';
import { IntennseService } from './intennse.service';
import { BreakClockService } from '../_shared/components/break-clock/break-clock.service';
import { BreakClockComponent } from '../_shared/components/break-clock/break-clock.component';

@Component({
  standalone: false,
  selector: 'app-intennse-official-view',
  templateUrl: './intennse-official-view.component.html',
  styleUrls: ['./intennse-official-view.component.scss'],
})
export class IntennseOfficialViewComponent implements OnInit, OnDestroy {
  private startMatchService = inject(StartMatchService);
  public authService = inject(AuthService);
  public officialViewService = inject(OfficialViewService);
  public themeService = inject(ThemeService);

  @ViewChild('header', { read: ElementRef }) header: ElementRef | undefined;
  @ViewChild('teamScoreCard', { read: ElementRef }) teamScoreCard: ElementRef | undefined;
  @ViewChild('clockBar', { read: ElementRef }) clockBar: ElementRef | undefined;
  @ViewChild('board') trackerBoardComponent: TrackerBoardComponent | undefined;
  @ViewChild('trackerBar') trackerBarComponent: TrackerBarComponent | undefined;
  @ViewChild('violationList') violationList: | InfringementListComponent | undefined;
  @ViewChild('pointBreakClock') pointBreakClock: StopwatchComponent | undefined;
  @ViewChild('setTimeClock') setTimeClock: StopwatchComponent | undefined;
  @ViewChild('warmUpClock') warmUpClock: StopwatchComponent | undefined;
  @ViewChild('confirmModal', { static: false }) confirmModal: IonModal | undefined;
  @ViewChild('clocksComponent') clocksComponent: ClocksComponent | undefined;
  @ViewChild('intSelectServer') intSelectServerComponent: IntSelectServerComponent;
  public readonly clockName: typeof ClockName = ClockName;

  match!: Match;
  tie: Tie | undefined;
  scoreFormat: ScoreFormat;
  private matchId!: string;
  rowStyle: any;
  isOwner = false;
  isTracker = false;
  isReverse = false;
  selectedSegment: SegmentValue = 'scoring';
  canViewOnDevice = false;
  isTablet = false;
  isMobile = false;
  numberOfRows: number = 3;
  rowHeight!: number;
  sideColors = ['#3f51b5', '#009688'];
  private readonly destroy$: Subject<void> = new Subject();
  headerHeight: any;
  teamSide1Players: any;
  teamSide2Players: any;
  isMatchStart: boolean = false;
  isPointStarted: boolean = false;
  isServerChange: boolean = false;
  serverWinningSide: number;
  matchTotalScore: any;
  isBoltEnd: boolean = false;
  endBoltMatchSubscription: any;
  matchCollectionName: string = '';
  matchTimeout: any;
  isTimeoutClock: Clock | undefined;
  isServerSelected: boolean = false;
  isTeamSelected: boolean = false;
  public selectedTeamSide: number | null = null;
  hideSelectServingAndServer: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private matchService: MatchService,
    public bhs: BoardHelpService,
    public platform: Platform,
    private cd: ChangeDetectorRef,
    private toast: ToastService,
    private matchTrackerService: MatchTrackerService,
    private tieDetailsService: TieDetailsService,
    private socket: Socket,
    private scoreService: ScoreService,
    private readonly modalController: ModalController,
    private clocksService: ClocksService,
    private intennseService: IntennseService,
    private breakClockService: BreakClockService
  ) {}

  async ngOnInit() {
    await this.officialViewInit();
    this.matchId = this.activatedRoute.snapshot.params['id'];
    this.getMatch();
    this.subscriptions();
  }

  startPoint() {
    this.hideSelectServingAndServer = false;
    this.isPointStarted = !this.isPointStarted;
    this.pointBreakClock?.pauseClock();
    this.trackerBoardComponent?.onStartPointFromIntennseUI();

    if(this.setTimeClock?.getCurrentClock()?.isPaused){
        this.setTimeClock?.startClock();
    }
  }

  async ngOnDestroy() {
    if (Capacitor.isNativePlatform()) {
      if (await Capacitor.isPluginAvailable('KeepAwake')) {
        await KeepAwake.allowSleep();
      }

      if (this.isTablet) {
        await ScreenOrientation.unlock();
      }
    }

    this.endBoltMatchSubscription.unsubscribe();
    this.scoreService.resetPlayerPositions();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async officialViewInit() {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isTablet = this.platform.is('tablet');
      this.isMobile = !this.isTablet;
      if (
        Capacitor.isNativePlatform() &&
        this.isTablet &&
        Capacitor.isPluginAvailable('ScreenOrientation')
      ) {
        await ScreenOrientation.lock({
          orientation: 'landscape',
        });
      }

      if (
        Capacitor.isNativePlatform() &&
        (await Capacitor.isPluginAvailable('KeepAwake'))
      ) {
        await KeepAwake?.keepAwake();
      }

      if (this.themeService.isDarkMode) {
        this.sideColors = ['#03a9f4', '#8bc34a'];
      }
      this.canViewOnDevice = true;
    }
  }

  async getMatch(refresher?: RefresherCustomEvent) {
    if (!refresher) {
      await this.loaderService.present();
    }

    this.matchService
      .show(this.matchId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(async () => {
          this.getAvailableHeight();
          this.updateOfficialView();
          await this.loaderService.dismiss();
        })
      )
      .subscribe({
        next: async (res) => {
          this.match = res.data;
          if (this.match.tie) {
            this.tie = await this.tieDetailsService.getTieInfo(
              this.match.tie,
              false,
              false,
              'intennse-view ln197'
            );

            /**
             *  Whenever page refresh Trigger tieMatches observable and auto-unsubscribe on destroy
             */
            this.tieDetailsService
              .getMatches(this.match.tie, true)
              .pipe(takeUntil(this.destroy$))
              .subscribe((matches) => {
                // Once all matches for the tie are fetched, recalculate and update the tie's aggregate score.
                this.bhs.updateTieAggregateScore(this.match)
              });

            // Filter tie format based on collectionId
            if (this.tie?.tieFormat?.collectionDefinitions) {
                const filteredCollection = this.tie.tieFormat.collectionDefinitions.filter(
                  collection => collection.collectionId === res.data.collectionId
                );
                this.matchCollectionName = filteredCollection ? filteredCollection[0]?.collectionName : '';
              }

            if (this.tie.sides[0].team?.colors.length)
              this.sideColors[0] = this.tie.sides[0].team?.colors[0];
            if (this.tie.sides[1].team?.colors.length)
              this.sideColors[1] = this.tie.sides[1].team?.colors[0];
            this.getSideScore();
          }

          this.scoreFormat = this.bhs.getScoreFormat(
            this.match.matchFormat,
            this.match.discipline
          );
          this.numberOfRows =
            this.scoreFormat.numberOfSets > 3
              ? this.scoreFormat.numberOfSets
              : 3;

          this.isOwner =
            this.match.dist.owner === this.authService.authUserSignal()?._id;
          this.isTracker = this.matchService.isTracker(this.match);

          this.teamSide1Players = {
            player1: this.getParticipantName(1, 1),
            player2: this.getParticipantName(2, 1),
          };

          this.teamSide2Players = {
            player1: this.getParticipantName(1, 2),
            player2: this.getParticipantName(2, 2),
          };

          if (this.match.matchStatus === MatchUpStatusEnum.TBP) {
            this.pointBreakClock?.clearClock();
            this.setTimeClock?.clearClock();
            this.warmUpClock?.clearClock();
          }

          this.isTimeoutClock = this.getClock(ClockName.TIMEOUT);

          if(this.match?.sets.length > 0 && this.isTimeoutClock){
            this.matchTimeout = this.match?.sets && this.clocksService.getTimeoutValuesFromSet(this.match?.sets?.[this.match.sets?.length - 1], this.match);
          }
        },
      });
  }

  getTimeoutData(side: 'side1' | 'side2') {
    return this.matchTimeout?.[side] || {};
  }
  
  getUsedTimeouts(side: 'side1' | 'side2'): number {
    const data = this.getTimeoutData(side);
    const total = data.timeoutPerSet ?? 0;
    const remaining = data.remainingTimeoutsPerSet ?? total;
    return total - remaining;
  }
  
  getDisplayableDots(side: 'side1' | 'side2'): number[] {
    const data = this.getTimeoutData(side);
    const used = this.getUsedTimeouts(side);
    const maxPerSet = data.timeoutPerSet ?? 0;
    const remainingMatch = data.remainingTimeoutsPerMatch ?? 0;
  
    // Always show previously used, and allow new only within match-level limit
    const totalDisplayDots = Math.min(maxPerSet, used + remainingMatch);
    return Array.from({ length: totalDisplayDots });
  }

  private updateOfficialView() {
    this.officialViewService.areSidesReversed = this.isReverse;
    this.rowStyle = this.matchTrackerService.getRowStyle(
      this.sideColors,
      this.isReverse
    );
    this.cd.detectChanges();
  }

  swapSides() {
    if (this.match.matchStatus !== 'COMPLETED') {
      this.isReverse = !this.isReverse;
      if (
        this.bhs
          .getLastPoint(this.match)
          ?.extensions?.find((ext) => ext.name === 'areSidesReversed')
      ) {
        this.bhs
          .getLastPoint(this.match)!
          .extensions!.find((ext) => ext.name === 'areSidesReversed')!.value =
          this.isReverse;
      }
      this.rowStyle = this.matchTrackerService.getRowStyle(
        this.sideColors,
        this.isReverse
      );
    }
  }

  getGameScore(set: Set, sideNumber: number): number {
    return set[`side${sideNumber}Score`];
  }

  // Add point
  // sideNumber: Which side won the point
  // point: Number of points won like +2 or +1
  async addPointScore(sideNumber, point: number) {
    if (!this.isCompleted()) {
      await this.trackerBoardComponent!.addPoint(
        sideNumber,
        'NONE',
        sideNumber,
        'SE',
        'I',
        'BL',
        null,
        point
      );
      this.getSideScore();
      this.resetAfterPoint();

      if (this.match.matchType === 'D') {
        this.serverChange(sideNumber);
      } else {
        this.isPointStarted = false;
      }
    }
  }

  checkServerChangeForTheFirstTime(match: Match, sideNumber: number): boolean {
    const lastPoint = this.bhs.getLastPoint(match);
    return (
      match.score?.server?.sideNumber !== sideNumber &&
      !lastPoint?.playerPositions?.[`side${sideNumber}`]?.deuce
    );
  }

  serverChange(sideNumber: number) {
    this.isServerChange = this.checkServerChangeForTheFirstTime(
      this.match,
      sideNumber
    );

    if (this.isServerChange) {
      this.isPointStarted = true;
    } else {
      this.isPointStarted = false;
    }
    this.serverWinningSide = sideNumber;
  }

  async ionViewWillEnter() {
    this.getSideScore();
  }
  async getSideScore() {
    this.socketSubscriptions();
    this.socket.emit('join-room', this.match?.tie);
  }

  private socketSubscriptions() {
    this.getTieStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: any) => {
        if (this.tie) {
          this.tie.winningSide = status.winningSide;
          this.tie.matchStatus = status.matchStatus;
          this.tie.score = status.score;
        }
        this.matchTotalScore = {
          side1Score: this.tieDetailsService.getScore(status.score)[0],
          side2Score: this.tieDetailsService.getScore(status.score)[1],
        };
      });
  }

  private getTieStatus() {
    const observable = new Observable((observer) => {
      this.socket.on('tie-status-updated', (data) => observer.next(data));
    });
    return observable;
  }

  resetServerWinningSide() {
    this.isServerChange = false;
    this.serverWinningSide = 0;
    this.isPointStarted = false;
    this.onReStartServerClock();
  }

  onServerSelected() {
    this.isServerSelected = true;
  }

  ace() {
    if (!this.isCompleted()) {
      const sideNumber = this.match.score!.server!.sideNumber;
      this.addPointScore(sideNumber, 2);
      // Deduct 1 second from setTimeClock
      if (this.setTimeClock) {
        this.setTimeClock.deductTime(1000); // 1000 milliseconds = 1 second
      }
    }
  }

  fault(shotOutcome: string) {
    if (!this.isCompleted() && this.pointBreakClock) {
      const sideNumber = this.match.score!.server!.sideNumber as number;
      this.trackerBoardComponent!.singleFault(sideNumber, shotOutcome);
      this.resetAfterPoint();
      this.isPointStarted = true;
      // Deduct 1 second from setTimeClock
      if (this.setTimeClock) {
        this.setTimeClock.deductTime(1000); // 1000 milliseconds = 1 second
      }
      
      if (this.match.matchType === 'D') {
        const winningSide = sideNumber === 1 ? 2 : 1;
        this.serverChange(winningSide);
      } else {
        this.isPointStarted = false;
      }
    }
  }

  undo() {
    this.trackerBoardComponent!.undo(true, true);

    if (this.match.score?.server?.sideNumber !== undefined) {
      this.isServerChange = this.checkServerChangeForTheFirstTime(
        this.match,
        this.match.score.server.sideNumber
      );
    }
    if (this.isServerChange) {
      this.isPointStarted = true;
    } else {
      this.isPointStarted = false;
    }

    this.pointBreakClock?.clearClock();
    this.pointBreakClock?.startClock();
  }

  private resetAfterPoint() {
    this.pointBreakClock?.clearClock();
    this.pointBreakClock?.startClock();
    this.setTimeClock?.updateClockOverSocket();
  }

  getWinningSetColor(set: Set, sideNumber: number): string | null {
    if (set.winningSide) {
      if (set.winningSide === sideNumber) {
        return this.sideColors[sideNumber - 1];
      } else {
        return '#808080';
      }
    }

    return null;
  }

  private getAvailableHeight() {
    setTimeout(() => {
      this.rowHeight = this.getRowHeight();
    });
  }

  async moreOptions() {
    await this.trackerBarComponent!.showMoreOptions();
  }

  getRowHeight(): number {
    const windowHeight: number = this.platform.height();
    const header = this.header?.nativeElement.offsetHeight;
    let rowCount = 8;
    if(!this.match.tie){
      rowCount = 7;
    }
    return this.isTablet ? (windowHeight - header) / rowCount : (windowHeight - header) / rowCount;
  }

  isCompleted(): boolean {
    return this.match.matchStatus === MatchUpStatusEnum.COMPLETED;
  }

  isInterrupted(): boolean {
    return (
      this.match.matchStatus === MatchUpStatusEnum.RETIRED ||
      this.match.matchStatus === MatchUpStatusEnum.DEFAULTED ||
      this.match.matchStatus === MatchUpStatusEnum.INCOMPLETE ||
      this.match.matchStatus === MatchUpStatusEnum.ABANDONED ||
      this.match.matchStatus === 'SUSPENDED'
    );
  }

  resumeSuspendedMatch() {
    const suspendedTimeItems = this.match.timeItems?.filter(
      (timeItem) =>
        timeItem.itemValue.interruptionReason ===
        InterruptionReason.MATCH_SUSPENSION
    );
    if (suspendedTimeItems?.length) {
      suspendedTimeItems[0].itemValue.duration =
        new Date().getTime() -
        new Date(suspendedTimeItems[0].itemDate!).getTime();
      this.match.matchStatus = MatchUpStatusEnum.IN_PROGRESS;

      this.match.score = this.scoreService.getScoreObject(this.match);

      this.matchService
        .updateTimeItem(
          this.match._id,
          suspendedTimeItems[0].itemId,
          suspendedTimeItems[0].itemValue
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.toast.presentToast(res.message);
          },
        });

      this.matchService
        .update(this.match, false)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.matchService.publishEdit(this.match);
          },
        });
    }
  }

  segmentChanged(ev: SegmentCustomEvent) {
    this.selectedSegment = ev.detail.value!;
  }

  async subscriptions() {
    this.matchService
      .subscribeScoreUpdated()
      .pipe(takeUntil(this.destroy$))
      .subscribe((match: Match) => {
        if (this.match._id === match._id) {          
            if(match.isIgnoreUpdate){
                // Update everything except clocks
                this.match = {
                    ...match,
                    clocks: this.match.clocks
                };
            } else {
                this.match = {
                  ...match,
                clocks: this.match.clocks
              };
            }
          this.updateOfficialView();
          this.getAvailableHeight();
          this.matchTimeout = this.match?.score?.sets?.[this.match?.score?.sets?.length - 1]?.timeout;
          this.isTimeoutClock = this.getClock(ClockName.TIMEOUT);

          this.teamSide1Players = {
            player1: this.getParticipantName(1, 1),
            player2: this.getParticipantName(2, 1),
          };

          this.teamSide2Players = {
            player1: this.getParticipantName(1, 2),
            player2: this.getParticipantName(2, 2),
          };


        }
        if (this.match.matchStatus === MatchUpStatusEnum.COMPLETED) {
          this.setTimeClock?.pauseClock();
        }
    });

    this.startMatchService
      .subscribeStartMatch()
      .pipe(takeUntil(this.destroy$))
      .subscribe((startMatch) => {
        if (this.match._id === startMatch.matchId && startMatch.matchActive) {
          if (this.match.score?.server) {
            this.pointBreakClock?.startClock();
            this.setTimeClock?.startClock();   
            this.isMatchStart = !this.isMatchStart;
            this.isPointStarted = false;
          }

          this.updateOfficialView();
          this.getAvailableHeight();
        }
      });

    this.platform.resize.subscribe((r) => {
      if (this.platform.isLandscape()) {
        this.getAvailableHeight();
      }
    });

    this.endBoltMatchSubscription = this.scoreService
      ?.endBoltMatchSubscription()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.setTimeClock?.clearClock();
        this.pointBreakClock?.clearClock();
        this.isPointStarted = false;
        this.isBoltEnd = false;

        // When bolt clock is end then Break clock start.
        const setNumber = this.getSetNumber(this.match?.matchFormat);        
        if (setNumber !== null && this.match.score?.sets?.length < setNumber) {
          this.breakClock();
        }
      });

    await this.bhs.tieScore$
          .pipe(takeUntil(this.destroy$))
          .subscribe((score: TieScore) => {
            if (this.match._id === score.matchId) {
              this.matchTotalScore = score;
          }
        });

    // Subscribe to the swapSides event
    await this.intennseService.swapSides$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.swapSides();
      });

    await this.matchService.subscribeFullMatchUndo()
      .pipe(takeUntil(this.destroy$))
      .subscribe((payload) => {
        // Handle full match undo here
        if( payload && payload.matchId === this.match._id && this.match.matchStatus === MatchUpStatusEnum.TBP) {
          // Reset the match state or perform any necessary actions
            this.isPointStarted = false;
            this.isServerSelected = false;
            this.isTeamSelected = false;
            this.isMatchStart = false;
            this.pointBreakClock?.clearClock();
            this.setTimeClock?.clearClock();
            this.hideSelectServingAndServer = true;
            this.selectedTeamSide = null;
            this.isBoltEnd = false;
        }
        // Your logic here
      });

    await this.breakClockService.subscribeBreakClock()
     .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.breakClock();
      });
  }

  async addOverrule(sideNumber: number) {
    await this.violationList!.addOverrule(sideNumber);
  }

  async addTimeViolation(sideNumber: number) {
    await this.violationList!.addTimeViolation(sideNumber);
  }

  async addInterruption(sideNumber: number) {
    await this.violationList!.addInterruption(sideNumber);
  }

  async addCodeViolation(sideNumber: number) {
    await this.violationList!.addCodeOfConduct(sideNumber);
  }

  getTeam(sideNumber: number) {
    return this.tie?.sides[sideNumber - 1].team;
  }

  getClock(clockName: ClockName): Clock | undefined {
    return this.match.clocks.find((c) => c.name === clockName);
  }

  getLastPoint() {
    return this.bhs.getLastPoint(this.match);
  }

  getLastGame() {
    return this.bhs.getLastGame(this.match);
  }

  getParticipantName(playerNumber: number, sideNumber: number) {
    if(this.tie){
      const tiePlayers = this.tie?.sides[sideNumber - 1]?.team?.participants ?? [];
      const matchPlayers = this.match?.sides[sideNumber - 1]?.players ?? [];

      const matchedActivePlayers = tiePlayers
        .map(sub => {
          const active = matchPlayers.find(mp => mp.participant._id === sub.person._id);
          return active ? { ...sub, playerNumber: active.playerNumber } : null;
        })
        .filter(Boolean)
        .sort((a, b) => a.playerNumber - b.playerNumber);

      const person = matchPlayers[playerNumber - 1]?.participant;
      const matchedPlayer = matchedActivePlayers[playerNumber - 1];

      if (!person || !matchedPlayer) return;

      return {
        name: `${person?.last_name?.toUpperCase()}, ${person?.first_name}`,
        id: person._id,
        jerseyNumber: matchedPlayer.jerseyNumber,
        profile_image: matchedPlayer.person.profile_image
      };
    } else {
      const person =
      this.match.sides[sideNumber - 1].players[playerNumber - 1]?.participant;
    if (person) {
      return {
        name: `${person?.last_name?.toUpperCase()}, ${person?.first_name}`,
        id: person._id,
        profile_image: person?.profile_image?.imageUrls?.original || null
      };
    }
  }
  
}

  async startMatch() {
    await this.intSelectServerComponent.startMatchIntennse();
  }

  onBoltClockEnd() {
    this.isBoltEnd = true;
  }

  async boltMatchEnd() {
    await this.trackerBoardComponent!.completeTimedSet();
  }

  resetAndStartClock() {
    this.onReStartServerClock();
    this.onReStartTimeClock();
    this.isPointStarted = false;
    this.isBoltEnd = false;
  }
  // show real time score on 
  async showRealTimeScore(){
    const modal = await this.modalController.create({
      component: ScoreSummaryComponent,
      componentProps: {
        match: this.match,
        tie: this.tie,
        matchTotalScore: this.matchTotalScore,
        matchCollectionName: this.matchCollectionName,
      },
        breakpoints: [0, 1],
        initialBreakpoint: 0.6
    });

    await modal.present();
  }

  setTimeClockIconClick() {
        this.setTimeClock?.startPauseClock();
  }
  pointBreakClockIconClick() {
    this.pointBreakClock?.startPauseClock();
  }

  onReStartServerClock(){
    this.pointBreakClock?.clearClock();
    this.pointBreakClock?.startClock();
  }

  onReStartTimeClock(){
    this.setTimeClock?.clearClock();
    this.setTimeClock?.startClock();
  }

  onTimeoutStarted(){
    this.setTimeClock?.pauseClock();
    this.pointBreakClock?.pauseClock();
  }

  onTimeoutUndo(){
    this.pointBreakClock?.startClock();
    this.setTimeClock?.startClock();
  }

  onTimeoutEnd(){
    this.pointBreakClock?.clearClock();
  }

  getSetNumber(str: string): number | null {
    const setPart = str.split('-')[0];
    const num = setPart.replace('SET', '');
    return isNaN(Number(num)) ? null : Number(num);
  }

  onTeamSelected(sideNumber: number) {
    this.selectedTeamSide = sideNumber;
    this.isTeamSelected = true; // if you use this flag elsewhere
  }

  undoTeamSelected() {
    this.isTeamSelected = false;
    this.selectedTeamSide = null; // Reset the selected team side
    this.isServerSelected = false;
  }

  async breakClock(){
    let allowDismiss = false; // Flag to control canDismiss
    const modal = await this.modalController.create({
      component: BreakClockComponent,
      componentProps: { match: this.match},
      backdropDismiss: true,
      breakpoints: [0, 0.5, 1],         // Optional: allows snapping between these sizes
      initialBreakpoint: 0.55,          // Modal starts at 50% height
      handle: true,                     // Shows a drag handle at the top
      canDismiss: async (data) => {
          if (!data) {
              this.breakClockService.breakConfirmation();
          }

          if(data?.closeModal){
            allowDismiss = true;
          }
         
          if(data?.breakEnd){
            allowDismiss = true;
            this.trackerBoardComponent?.endBreak();
          }

          if(data?.breakUndo){
            allowDismiss = true;
            this.trackerBoardComponent?.undoBreak();
          }

          return allowDismiss; // return true to allow closing
        }
    });

    this.trackerBoardComponent?.startBreak();
    await modal.present();
    const { data } = await modal.onDidDismiss();
  }

  setClockIconClick(clock: StopwatchComponent | undefined) {
    clock?.startPauseClock();
  }

}
